import type ConsentService from './ConsentService';
import LocalConsentService from './LocalConsentService';
import RemoteConsentService from './RemoteConsentService';
import Tracker from './Tracker';
import WrappingConsentService from './WrappingConsentService';
import type { Fetch } from './Fetch';

export default class ConsentServiceFactory {
    public static create(baseUrl: string, fetch?: Fetch): ConsentService {
        return new WrappingConsentService(
            new LocalConsentService(new Tracker()),
            new RemoteConsentService(baseUrl, fetch),
        );
    }
}
